export const ASSIGNMENTS_TRAIL = 200;

// coupled with some values in CSS
export const CARD_REMOVAL_DURATION = 800;

export const SECTIONS_TRANSITION_TIMEOUT = 500;
